// Modules
import { useState, useEffect } from "react"
import { toast } from "react-toastify"
import { useParams } from "react-router-dom"

// Services
import MessageService from "~services/MessageService"

// Components
import PageContent from "~components/PageContent"
import MessageDetail from "~components/messages/MessageDetail"

// Interfaces
import { MessageShape } from "~shapes/message"

const Message = () => {
  const { id } = useParams<{ id: string }>()

  // Component state
  const [message, setMessage] = useState<MessageShape>(null!)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  // Component effects
  useEffect(() => {
    if (id) fetchMessage(id!)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const fetchMessage = (id: string) => {
    setIsLoading(true)
    MessageService.getMessage(id)
      .then((m: MessageShape) => {
        setMessage(m)
      })
      .catch(() => {
        toast.error(`Failed to load the Message`)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <PageContent>
      <MessageDetail message={message} isLoading={isLoading} />
    </PageContent>
  )
}

export default Message
